import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token:
    localStorage.getItem("token") !== "null"
      ? localStorage.getItem("token")
      : null,
  loginUser: null,
  error: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const Slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.err}`;
      state.listLoading = state.actionsLoading = false;
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list)
        state.listLoading = true;
      else state.actionsLoading = true;
    },
    login: (state, action) => {
      state.error = null;
      state.loginUser = action.payload;
    },
    // ✅ EKLEDİK
    setLoginUser: (state, action) => {
      state.loginUser = action.payload;
    },
    setToken: (state, action) => {
      state.error = null;
      state.token = action.payload;
      localStorage.setItem("token", action.payload);
    },
    logOut: () => {
      localStorage.removeItem("token");
      localStorage.removeItem("persist:root");
      return { token: null, loginUser: null, error: null };
    },
    registerUser: (state) => {
      state.error = null;
    },
    setUsers: (state, action) => {
    state.users = action.payload;
},
  },
});


export const { setLoginUser, setUsers } = Slice.actions;

export default Slice.reducer;
